import React from "react";
import "../contentcard.css";
import { Col, Table, Typography, Tag } from "antd";
import { DownArrow } from "../../../components/Icons/DownArrow";
import { UpArrow } from "../../../components/Icons/UpArrow";
import { Link } from "react-router-dom";
import {
  dateFormat,
  statusColorMapping,
} from "../../../commonFuntions/CommonUtilFunctions";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";

export const RejectedBySeller = (props) => {
  const { data } = props;
  const { Text } = Typography;
  const columns = [
    {
      title: "Order ID",
      dataIndex: "order_id",
      key: "order_id",
      render: (value, record) => (
        <Link
          to={`/admin/orders/order-details/${record?.id}`}
          target="_blank"
          className="dashboard-table-orderid"
        >
          {value || "-"}
        </Link>
      ),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (params) => <Text className="">{dateFormat(params)}</Text>,
    },
    {
      title: "Customer",
      key: "customer",
      render: (_, record) => (
        <Col>
          <Text>{record?.name || "-"}</Text>
          <br />
          <Text type="secondary">{record?.mobile_number || "-"}</Text>
        </Col>
      ),
    },
    // {
    //   title: "Rejected At",
    //   dataIndex: "latest_rejected_at_english",
    //   key: "latest_rejected_at_english",
    //   render: (value) => <Text>{value || "-"}</Text>,
    // },
  ];

  const tableData = (data || []).map((item) => ({
    key: item?.id || item?.order_id,
    ...item,
  }));
  const expandable = {
    expandedRowRender: (record) => (
      <Col className="rejected-suborder-wrapper">
        {(record?.rejected_sub_orders || []).map((subOrder, idx) => (
          <Col
            className="rejected-suborder-row"
            key={subOrder?.suborder_id || idx}
          >
            <Col className="rejected-suborder-main">
              <Col className="rejected-suborder-id">
                <Text className="rejected-suborder-id-label">Sub ID</Text>
                <Text className="rejected-suborder-id-value">
                  {subOrder?.suborder_id || "-"}
                </Text>
              </Col>
              <Col className="rejected-suborder-time">
                <Text className="rejected-suborder-time-label">Rejected at</Text>
                <Text className="rejected-suborder-time-value">
                  {subOrder?.rejected_at_english || "-"}
                </Text>
              </Col>
            </Col>
            <Col className="rejected-suborder-status">
              <Tag
                className={`rejected-suborder-tag ${
                  statusColorMapping[subOrder?.status] || ""
                }`}
              >
                {subOrder?.status || "Rejected by seller"}
              </Tag>
            </Col>
          </Col>
        ))}
      </Col>
    ),
    expandIcon: ({ expanded, onExpand, record }) =>
      expanded ? (
        <UpArrow
          className="cursor rejected-expand-icon"
          onClick={(event) => onExpand(record, event)}
        />
      ) : (
        <DownArrow
          className="cursor rejected-expand-icon"
          onClick={(event) => onExpand(record, event)}
        />
      ),
    rowExpandable: (record) => (record?.rejected_sub_orders || []).length > 0,
  };

  return (
    <>
      <Col className="rejected-card-container">
        <Table
          className="rejected-parent-table"
          expandable={expandable}
          columns={columns}
          dataSource={tableData}
          pagination={false}
          size="small"
          scroll={{ x: "max-content" }}
          locale={{
          emptyText: <NoDataFound text={"No Order Found!"} />,
        }}
        />
      </Col>
    </>
  );
};
